import { history } from '../../store';

const BrandItem = (props) => {
  const {
    index,
    name,
    image,
    handleBanner,
  } = props;

  return (
    <div>
      <div className="carousel-item" onMouseEnter={() => handleBanner(index)} onTouchStart={() => handleBanner(index)}>
        <img src={image} alt={name} />
      </div>
      <div
        className="carousel-item-title"
        onClick={() => {
          if (name) {
            history.push(`#${name}`);
          }
        }}
      >
        {name}
      </div>
    </div>
  );
};

export default BrandItem;
